import { render, staticRenderFns } from "./Valuation.vue?vue&type=template&id=b30c5ca4&"
import script from "./Valuation.vue?vue&type=script&lang=js&"
export * from "./Valuation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports